import React, { useState, useEffect,useContext } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate} from 'react-router-dom';
import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import SelectBox2 from '../../../Components/Select2';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../../GlobalContext';
import Select from "react-select";

const CreateUser = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const userId = { userID: decodedToken.id };

    const { setCountData } = useContext(GlobalContext);

    const date = new Date();

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    const [companyList, setCompanyList] = useState([]);
    const fetchCompany = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/companys/get`, { userId },
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
            .then(response => {
                setCompanyList(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
    }

    const [groupList, setGroupList] = useState([]);
    const fetchGroup = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/groups/get`, { userId },
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
            .then(response => {
                setGroupList(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
    }
    useEffect(() => {
        fetchGroup();
        fetchCompany();
    }, []);

    const [checkedUserType, setCheckedUserType] = useState(false);

    const [gpsService, setGpsService] = useState('OFF');
    const [recordingService, setRecordingService] = useState('OFF');
    const [sosService, setSosService] = useState('OFF');
    const [boundingService, setBoundingService] = useState('OFF');
    const [duplexService, setDuplexService] = useState('OFF');

    const [staffNameData, setStaffNameData] = useState([]);
    const [staffImeiData, setStaffImeiData] = useState([]);
    const [staffIccideData, setStaffIccidData] = useState([]);
    const fetchStaffData = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/staffs/get`, { userId },
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
            .then(response => {
                console.log('staffData', response.data.data);
                const staffData = response.data.data;
                const staffNames = staffData.map(staff => staff.nick_name);
                setStaffNameData(staffNames);
                const staffImei = staffData.map(staff => staff.imei);
                setStaffImeiData(staffImei);
                const staffIccid = staffData.map(staff => staff.iccid);
                setStaffIccidData(staffIccid);

                // console.log('============',staffNames,staffIccid,staffImei);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
    }
    useEffect(() => {
        fetchStaffData();
    }, []);

    const [staffData, setStaffData] = useState({ 
        nick_name:'',
        imei: '',
        iccid: '',
        online_status:'',
        last_login_date: '',
        UserID: '',
        notes:'',
        agent_notes:'',
        company_id:'',
        group_ids:[]
    });
    const [imeivalue, setImeiValue] = useState('');
    const [addPossibleIMEI, setAddPossibleIMEI] = useState(false);

    const handleStaffChange = (e) => {
        setStaffData({
            ...staffData,
            [e.target.name]: e.target.value,
        });
    };

    const [imeiError, setImeiError] = useState('');
    const validateIMEI = (imei) => {
        if (!/^\d{15}$/.test(imei)) {
            return { isValid: false, message: 'IMEI must be exactly 15 digits.' };
        }
    
        let sum = 0;
        for (let i = 0; i < 14; i++) {
            let digit = parseInt(imei[i]);
            if (i % 2 === 0) { // Double digits at even indices (0-based: 0, 2, 4, 6, 8, 10, 12)
                let doubled = digit * 2;
                sum += doubled > 9 ? doubled - 9 : doubled;
            } else {
                sum += digit;
            }
        }
        sum += parseInt(imei[14]);
        // const isValid = sum % 10 === 0;
        const isValid = true;
    
        return {
            isValid,
            message: isValid ? '' : 'Invalid IMEI. Please check the number.',
        };
    };

    const handleImeiChange = (e) => {
        const value = e.target.value;
        setImeiValue(value);
        const { message } = validateIMEI(value);
        setImeiError(message);
    };

    const [selectedCompany, setSelectedCompany] = useState(null);
    const changeCompany = (option) => {
        // //console.log(option,'options');
        setSelectedCompany(option);
        if(option) {
            setStaffData({
                ...staffData,
                ['company_id']: option._id,
            });
        } else {
            setStaffData({
                ...staffData,
                ['company_id']: '',
            });
        }
    };

    const [selectedGroup, setSelectedGroup] = useState(null);
    const changeGroup = (options) => {
        // //console.log(option,'options');
        setSelectedGroup(options);
        if(options) {
            const selectedValues = options ? options.map(option => option._id) : [];
            setStaffData({
                ...staffData,
                ['group_ids']: selectedValues,
            });
        } else {
            setStaffData({
                ...staffData,
                ['group_ids']: [],
            });
        }
    };

    const [file1, setFile1] = useState(null);
    const [file1Name, setFile1Name] = useState('');
    const handleFileChange1 = (e) => {
        setFile1(e.target.files[0]);
    };
    const [file2, setFile2] = useState(null);
    const handleFileChange2 = (e) => {
        setFile2(e.target.files[0]);
    };

    useEffect(() => {
        if(file1) {
            setFile1Name(file1.name);
        }
    }, [file1]); // This will run whenever file1 changes

    const resetCount = async() => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;
        await axios.post(`${POCBaseUrl}/users/count`,
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Token: token,
                },
              }
        )
        .then(response => {
            setCountData(response.data.data);
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }

    const handleAddIMEI = async() => {
        if (imeivalue === '') {
            toast.warn("Please input IMEI", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
            return;
        }

        if (imeiError) {
            toast.warn("IMEI contains 15 numbers.", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
            return;
        }

        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;
        const response = await axios.post(`${POCBaseUrl}/staffs/addimei`, {imeivalue: imeivalue},
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Token: token,
                },
              }
        );
        if(response.data.success) {
            setAddPossibleIMEI(true);
            setStaffData({
                ...staffData,
                imei: imeivalue,
            });

            toast.success("Created successfully!", {
                className: 'centered-toast-success',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
        } else {
            toast.warn("Account already exists!", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                pauseOnFocusLoss: true
            });
        }
    }

    const handleStaffCreate = async() => {

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            if (staffData.company_id === '') {
                toast.warn("Please select Company", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            if (staffData.nick_name === '') {
                toast.warn("Please input nick name", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            if (staffData.imei === '') {
                toast.warn("Please input IMEI", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            if (imeiError) {
                toast.warn("IMEI contains 15 numbers.", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            //add imei
            if (!addPossibleIMEI) {
                toast.warn("Please enter IMEI!", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            const formDataObj = new FormData();
            formDataObj.append('account', file1);
            Object.keys(staffData).forEach(key => {
                formDataObj.append(key, staffData[key]);
            });

            for (let [key, value] of formDataObj.entries()) {
                console.log(key, value);
            }

            const response = await axios.post(`${POCBaseUrl}/staffs/create`, formDataObj,
                {
                    headers: {
                      "Content-Type": "multipart/form-data", // Specify content type
                      Token: token,
                    },
                  }
            );
            if(response.data.success) {
                toast.success("Created successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
            
                resetCount();
                setStaffData({ 
                    nick_name:'',
                    imei: '',
                    iccid: '',
                    online_status:'',
                    last_login_date: '',
                    notes:'',
                    agent_notes:'',
                    company_id:'',
                    group_ids:[]
                });
                navigate('/userlist');
            } else {
                toast.warn(response.data.message , {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                });
            }
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Company belonged to'} className={'!w-[170px]'} />
                        </div>
                        <div className={ `w-[360px] text-gray-500 bg-[transparent] text-sm tracking-wide flex items-center rounded cursor-pointer hover:!border-[#2776c3] bg-[transparent]`}>
                            <Select
                                name="companylist"
                                placeholder={"Select a company"}
                                className={`basic-multi-select w-full cursor-pointer !m-0 !p-0`}
                                classNamePrefix="select"
                                options={companyList}
                                value={selectedCompany}
                                onChange={changeCompany}
                                getOptionLabel={(option) => option.name} // Show only the label
                                getOptionValue={(option) => option._id}
                                styles={{
                                    control: (provided) => ({
                                    ...provided,
                                    borderColor: '#dcdfe6', // Change border color based on focus state
                                    boxShadow: 'none', // Remove default shadow
                                    '&:hover': {
                                        borderColor: '#2776c3', // Change border color on hover
                                    },
                                    }),
                                }}
                            />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select a company</span>
                    </div>
                    <div className='mb-[22px] flex hidden'>
                        <div className='w-[170px]'>
                            <Label text={'Groups to join'} className={'!w-[170px]'} />
                        </div>
                        <div className={ `w-[360px] text-gray-500 bg-[transparent] text-sm tracking-wide flex items-center rounded cursor-pointer hover:!border-[#2776c3] bg-[transparent]`}>
                            <Select
                                isMulti
                                name="grouplist"
                                placeholder={"Select a group"}
                                className={`basic-multi-select w-full cursor-pointer !m-0 !p-0`}
                                classNamePrefix="select"
                                options={groupList}
                                value={selectedGroup}
                                onChange={changeGroup}
                                getOptionLabel={(option) => option.name} // Show only the label
                                getOptionValue={(option) => option._id}
                                isDisabled
                                styles={{
                                    control: (provided) => ({
                                    ...provided,
                                    borderColor: '#dcdfe6', // Change border color based on focus state
                                    boxShadow: 'none', // Remove default shadow
                                    '&:hover': {
                                        borderColor: '#2776c3', // Change border color on hover
                                    },
                                    }),
                                }}
                            />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'User nick name prefix'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name={'nick_name'} value={staffData.nick_name || ''} onChange={handleStaffChange} placeholder={'Mandatory fill (2-7 letters)'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>2-7 digits consisting of letters, numbers or underline but not starting with underline, batch user nickname suffix plus natural number, repeated name continuation of natural number</span>
                    </div>
                    {/* <div className='mb-[22px] flex items-center'>
                        <div className='w-[170px]'>
                            <Label text={'Import Account'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <div className={`w-[360px] m-0 p-0`}>
                                <div className="relative text-[14px] inline-block w-full flex flex-col justify-center">
                                    <div
                                        className={`flex flex-col justify-center bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit h-[40px] leading-[40px] outline-none`}
                                    >
                                    {file1Name !== '' &&(
                                        <div className='flex justify-between pl-1 w-full h-[25px] bg-[transparent] hover:bg-[#eff6ff] transition-colors duration-200 group'>
                                            <div className='flex'>
                                                <div className='flex flex-col justify-center '>
                                                    <svg
                                                    className="h-[25px]"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    data-testid="DescriptionIcon"
                                                    tabIndex="-1"
                                                    title="Description"
                                                    style={{ width: '24px', height: '24px' }} // You can adjust the size as needed
                                                    fill='#606266'
                                                    >
                                                    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"></path>
                                                    </svg>
                                                </div>
                                                <div className='flex flex-col justify-center pl-1 text-[13px] text-[#606266] hover:underline'>
                                                    <span>{file1Name}</span>
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center pr-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200'>
                                                <svg
                                                    className="h-4 w-4 text-gray-500 focus:outline-none focus:border-0"
                                                    focusable="false"
                                                    
                                                    viewBox="0 0 24 24"
                                                    data-testid="CloseIcon"
                                                    tabIndex="-1"
                                                    title="Close"
                                                    fill='#606266'
                                                >
                                                    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                </svg>
                                            </div>
                                        </div>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <label
                            htmlFor="uploadFile1"
                            className="flex bg-[#2776c3] h-[32px] text-white text-[12px] items-center px-4 outline-none rounded cursor-pointer ml-2"
                            style={{ fontFamily: 'Liberation Serif' }}
                        >
                            Upload
                            <input
                                type="file"
                                id="uploadFile1"
                                className="hidden"
                                onChange={handleFileChange1}
                            />
                        </label>
                        <label
                            htmlFor="uploadFile1"
                            className="flex bg-[#2776c3] h-[32px] text-white text-[12px] items-center px-4 outline-none rounded cursor-pointer ml-2"
                            style={{ fontFamily: 'Liberation Serif' }}
                        >
                            Import
                            <input
                                type="file"
                                id="uploadFile2"
                                className="hidden"
                                // onChange={handleFileChange}
                            />
                        </label>
                        <Link className='ml-2 text-[#5A5655]'><u>Click to Download Template</u></Link>
                    </div> */}
                    {/* <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <div className='bg-[#fff] round-md w-[360px] h-[200px]'></div>
                        </div>
                    </div> */}
                    <div className={`${imeiError ? 'mb-[10px]' : 'mb-[22px]'}  flex`}>
                        <div className='w-[170px]'>
                            <Label text={'IMEI'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <div className={`w-[360px] m-0 p-0`}>
                                <div className="relative flex bg-[white] text-[14px] inline-block w-full border border-[#dcdfe6] rounded">
                                    <input
                                        name = "imei"
                                        value={imeivalue || ''}
                                        pattern="[0-9]*"
                                        type = {'text'}
                                        autoComplete="off"
                                        placeholder={'please enter IMEI'}
                                        className={`w-full bg-white rounded inline-block text-inherit h-[40px] leading-[40px] outline-none px-[15px]`}
                                        onChange={handleImeiChange}
                                    />
                                    <div className='flex flex-col justify-center pr-2 cursor-pointer' onClick={() => handleAddIMEI()}>
                                        <svg
                                        className="w-2 h-2 pt-[3px]"
                                        focusable="false"
                                        viewBox="0 0 28 28"
                                        data-testid="AddCircleIcon"
                                        title="AddCircle"
                                        style={{ width: '24px', height: '24px'}} // You can adjust the size as needed
                                        fill='#606266'
                                        >
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#2776c3] ml-[10px] text-[14px]'>{staffData.imei && staffData.imei || ''}</span>
                    </div>
                    {imeiError && (
                        <div className='mb-[20px]'>
                            <span className="ml-[170px] h-[24px] text-[#fc3b3e] ml-[10px] text-[14px]">
                                {imeiError}
                            </span>
                        </div>
                    )}
                    {/* <div className='mb-[22px] flex items-center'>
                        <div className='w-[170px]'>
                            <Label text={'User type'} className={'!w-[170px]'} />
                        </div>
                        <div className='flex justify-between w-[360px]'>
                            <div className='flex flex-col justify-center'>
                                <div className='relative text-[14px] h-[20px] cursor-pointer items-center' onClick={() => setCheckedUserType(true)}>
                                    <div className="flex items-center mb-4 cursor-pointer">
                                        <label
                                            htmlFor="disabled-checkbox"
                                            className="ms-2 text-sm font-medium text-[black] mr-2 cursor-pointer"
                                        >
                                            Single function card user
                                        </label>
                                        {checkedUserType === true ?
                                            <svg
                                                className="w-5 h-5 outline-none"
                                                focusable="false"
                                                viewBox="0 0 24 24"
                                                data-testid="RadioButtonCheckedIcon"
                                                tabIndex="-1"
                                                title="RadioButtonChecked"
                                                fill='#2776c3'
                                            >
                                                <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                            </svg>
                                            :
                                            <svg
                                                className="w-5 h-5 outline-none"
                                                focusable="false"
                                                viewBox="0 0 24 24"
                                                data-testid="RadioButtonUncheckedIcon"
                                                tabIndex="-1"
                                                title="RadioButtonUnchecked"
                                                fill='#2776c3'
                                            >
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                            </svg>
                                        }
                                        <input
                                            disabled
                                            id="disabled-checkbox"
                                            type="checkbox"
                                            value={checkedUserType}
                                            checked={checkedUserType}
                                            onChange={() => setCheckedUserType(true)}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col justify-center'>
                                <div className='relative text-[14px] h-[20px] cursor-pointer' onClick={() => setCheckedUserType(false)}>
                                    <div className="flex items-center mb-4">
                                        <label
                                            htmlFor="disabled-checkbox"
                                            className="ms-2 text-sm font-medium text-[black] mr-2 cursor-pointer"
                                        >
                                            VIP card user
                                        </label>
                                        {checkedUserType === false ?
                                            <svg
                                                className="w-5 h-5 outline-none"
                                                focusable="false"
                                                viewBox="0 0 24 24"
                                                data-testid="RadioButtonCheckedIcon"
                                                tabIndex="-1"
                                                title="RadioButtonChecked"
                                                fill='#2776c3'
                                            >
                                                <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                            </svg>
                                            :
                                            <svg
                                                className="w-5 h-5 outline-none"
                                                focusable="false"
                                                viewBox="0 0 24 24"
                                                data-testid="RadioButtonUncheckedIcon"
                                                tabIndex="-1"
                                                title="RadioButtonUnchecked"
                                                fill='#2776c3'
                                            >
                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                            </svg>
                                        }
                                        <input
                                            disabled
                                            id="disabled-checkbox"
                                            type="checkbox"
                                            value={!checkedUserType}
                                            checked={!checkedUserType}
                                            onChange={() => setCheckedUserType(false)}
                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>VIP card users can directly activate permanent voice, positioning, recording, SOS, and fence services</span>
                    </div> */}
                    {/* {checkedUserType && (
                        <div className='mb-[22px] flex'>
                            <div className='w-[170px]'>
                                <Label text={'GPS service'} className={'!font-medium'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <span onClick={() => setGpsService('ON')} className={`${gpsService === 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>ON</span>
                                <span onClick={() => setGpsService('OFF')} className={`${gpsService === 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>OFF</span>
                            </div>
                        </div>
                    )}
                    {checkedUserType && (
                        <div className='mb-[22px] flex'>
                            <div className='w-[170px]'>
                                <Label text={'Recording service'} className={'!font-medium'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <span onClick={() => setRecordingService('ON')} className={`${recordingService === 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>ON</span>
                                <span onClick={() => setRecordingService('OFF')} className={`${recordingService === 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>OFF</span>
                            </div>
                        </div>
                    )}
                    {checkedUserType && (
                        <div className='mb-[22px] flex'>
                            <div className='w-[170px]'>
                                <Label text={'SOS service'} className={'!font-medium'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <span onClick={() => setSosService('ON')} className={`${sosService === 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>ON</span>
                                <span onClick={() => setSosService('OFF')} className={`${sosService === 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>OFF</span>
                            </div>
                        </div>
                    )}
                    {checkedUserType && (
                        <div className='mb-[22px] flex'>
                            <div className='w-[170px]'>
                                <Label text={'Bounding service'} className={'!font-medium'} />
                            </div>
                            <div className='relative text-[14px] leading-[40px]'>
                                <span onClick={() => setBoundingService('ON')} className={`${boundingService === 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>ON</span>
                                <span onClick={() => setBoundingService('OFF')} className={`${boundingService === 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>OFF</span>
                            </div>
                        </div>
                    )} */}
                    {/* <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Duplex service'} className={'!font-medium'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <span onClick={() => setDuplexService('ON')} className={`${duplexService === 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>ON</span>
                            <span onClick={() => setDuplexService('OFF')} className={`${duplexService === 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} bg-[#fdfdfd] py-1 px-[69px] mr-5 cursor-pointer select-none`}>OFF</span>
                        </div>
                    </div> */}
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Notes'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px] w-[360px]'>
                            <textarea
                                placeholder="User notes: within 100 characters"
                                className="p-4 bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                                rows="4"
                                name={'notes'}
                                onChange={handleStaffChange}
                            ></textarea>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Agent note'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px] w-[360px]'>
                            <textarea
                                placeholder="Agent note: whithin 100 characters"
                                className="p-4 bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                                rows="4"
                                name={'agent_notes'}
                                onChange={handleStaffChange}
                            ></textarea>
                        </div>
                    </div>
                    {/* <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Number of users'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField placeholder={'0'} disabled={true} className={'cursor-not-allowed'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Max. 1010 users can be created each time</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'created'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className='mt-2.5 bg-[#f0f0f0]' >
                <button onClick={handleStaffCreate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2.5 px-24 rounded text-white cursor-pointer' style={{ fontFamily: 'Liberation Serif' }}>
                    Save
                </button>
            </div>
        </>
    );
}

export default CreateUser;